import axios from 'axios'

export const CLAIMS_OVERVIEW_ENDPOINTS = Object.freeze({
  statusDistribution:
    '/motor-assessment/api/v1/claim/overview/status-distribution',
})

export const CACHED_STATUS_DISTRIBUTION = Object.freeze({
  draft: 0,
  pendingSending: 0,
  completeInGis: 0,
  actionRequired: 0,
  validationFailed: 0,
  total: 0,
})

export async function getStatusDistribution(claimType) {
  const params = claimType && claimType !== 'all' ? { claimType } : {}
  const res = await axios.get(CLAIMS_OVERVIEW_ENDPOINTS.statusDistribution, {
    params,
  })
  return res.data
}

export const ClaimsOverviewService = { getStatusDistribution }
export default ClaimsOverviewService
